import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { useLocation, Redirect } from "react-router-dom";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import DropdownComponent from "../../../App/Components/Dropdown/DropdownComponent";
import { editTrackingPixel } from "../TrackingPixelService";

function TrackingPixelDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [id, setId] = useState("");
  const [clientId, setClientId] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [name, setName] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [types, setTypes] = useState([
    { name: "MiQ Universal", val: 1 },
    { name: "MiQ Landing Page", val: 2 },
    { name: "MiQ Conversion", val: 3 },
  ]);

  const checkInput = () => {
    if (name === "" || endpoint === "") {
      return false;
    }
    return true;
  };

  function savePixel() {
    if (!checkInput()) {
      setInputError(true);
      return;
    }

    let data = {
      Id: id,
      ClientId: clientId,
      Name: name,
      Type: selectedType.val,
      Endpoint: endpoint,
      IsActive: isActive,
    };

    callAPI(
      editTrackingPixel(data),
      "Pixel Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {
      setClientId(location.state.clientId);
      setIsActive(location.state.isActive);
      setName(location.state.name);
      setEndpoint(location.state.endpoint);
      setId(location.state.id);
      for (var i in types) {
        if (types[i].val === location.state.type) {
          setSelectedType(types[i]);
        }
      }
    }
  }, []);

  if (location.state === null || location.state === undefined) {
    return <Redirect to="/trackingpixels" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/trackingpixels" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Tracking Pixel Detailed
        </h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <DropdownComponent
                      currValue={selectedType}
                      items={types}
                      property="name"
                      title="Type"
                      handleChange={(value) => setSelectedType(value)}
                    />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      className={classes.copy}
                      control={
                        <Checkbox
                          color="primary"
                          checked={isActive}
                          onChange={() => setIsActive(!isActive)}
                        />
                      }
                      label="Is Active?"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && name === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {inputError && name === "" && (
                      <FormHelperText className={classes.error}>
                        Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Endpoint"
                      label="Endpoint"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && endpoint === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={endpoint}
                      onChange={(e) => setEndpoint(e.target.value)}
                    />
                    {inputError && endpoint === "" && (
                      <FormHelperText className={classes.error}>
                        Endpoint Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid
                    container
                    justifyContent="flex-end"
                    direction="row"
                    style={{ marginRight: "10px" }}
                  >
                    <Grid item xs={6} sm={3}></Grid>
                    <Grid item xs={6} sm={3}>
                      <Button
                        style={{ marginTop: "20px", marginLeft: "10px" }}
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => savePixel()}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default TrackingPixelDetailed;
